<script setup>
import { provide } from 'vue'
import {useForm} from "~/composables/useForm.js";

const { registerField, unregisterField, validate, resetValidation, errors, isValid, updateFormValidation } = useForm()

provide('formContext', { registerField, unregisterField, errors, isValid, updateFormValidation })

defineExpose({
  validate,
  resetValidation,
  errors,
  isValid,
  updateFormValidation
})
</script>

<template>
  <form class="validation-form">
    <slot/>
  </form>
</template>

<style scoped>
.validation-form {
  width: 100%;
}
</style>
